module.exports = __webpack_public_path__ + "img/bg_dashiji_top@2x.c9d83b50.png";